import {combineReducers} from "redux"
import register from "./RegisterReducer"


export default combineReducers({
	register
})
